import React from 'react';
import {
  GET_SITE_INFO,
  PROCESS_SITE_INFO,
  SITE_INFO_ERROR,
  loadSiteInfo,
  GET_SYS_PARAMS,
  PROCESS_SYS_PARAMS,
  SYS_PARAMS_ERROR,
  loadSysParams,
} from '../actions/systemActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import { showLoading, hideLoading, addUiMsg } from '../actions/uiActions';
import { apiRequest } from '../actions/apiActions';
import { errorDisplay } from '../../utilities/general';
import { messageTypes } from '../../components/ui/AlertMessage';
import { FormattedMessage } from 'react-intl';
import sort from '../../utilities/sort';

export const getSiteInfo = (store) => (next) => (action) => {
  next(action);
  if (action.type === GET_SITE_INFO) {
    const body = null;
    const meta = {
      method: 'GET',
      url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].siteinfo,
      onSuccess: PROCESS_SITE_INFO,
      onError: SITE_INFO_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(body, meta));
  }
};

export const processSiteInfo = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_SITE_INFO) {
    dispatch(loadSiteInfo(action.payload.results[0]));
    dispatch(hideLoading());
  }
};

export const siteInfoError = (store) => (next) => (action) => {
  next(action);
  if (action.type === SITE_INFO_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="systemMiddleware.systemErrorMessage"
          defaultMessage="There was an error"
          description="The user statuses were not able to be loaded"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};
export const getSysParams = (store) => (next) => (action) => {
  next(action);
  if (action.type === GET_SYS_PARAMS) {
    const body = null;
    const meta = {
      method: 'GET',
      url:
        apiUrls.baseUrl +
        apiVersion +
        apiUrls[apiVersion].parameters +
        '?active=1',
      onSuccess: PROCESS_SYS_PARAMS,
      onError: SYS_PARAMS_ERROR,
      auth: store.getState().auth.token,
      body: false,
    };
    store.dispatch(showLoading());
    store.dispatch(apiRequest(body, meta));
  }
};

export const processSysParams = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_SYS_PARAMS) {
    const results = action.payload.results;
    let alertDeviceAccess = sort(
      results.filter((param) => param.name === 'alert device access by user'),
      'create_date',
      'za',
    );
    
    
    // Used to indicate the launch code from Onsolve or NotifyPro API key that will be set in the system parameters
    let massNotificationAccess = sort(
      results.filter((param) => param.name === 'ecn launch code' || param.name === 'notifypro api key'),
      'create_date',
      'za',
    );
    let paramObj = {
      alertDeviceAccess:
        alertDeviceAccess.length > 0 ? alertDeviceAccess[0] : null,
      massNotificationAccess:
      // If no parameter is set will indicate as null
       massNotificationAccess && massNotificationAccess.length > 0 ? massNotificationAccess[0] : null,
    };

    dispatch(loadSysParams(paramObj));
    dispatch(hideLoading());
  }
};






export const sysParamsError = (store) => (next) => (action) => {
  next(action);
  if (action.type === SYS_PARAMS_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="systemMiddleware.systemErrorMessage"
          defaultMessage="There was an error"
          description="The user statuses were not able to be loaded"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const systemMdl = [
  getSiteInfo,
  processSiteInfo,
  siteInfoError,
  getSysParams,
  processSysParams,
  sysParamsError,
];
